import React from 'react';
import { motion } from 'framer-motion';
const comparisonData = [{
  metric: 'Exclusividad',
  before: 'Compartido con 5+',
  after: '100% Tuyo'
}, {
  metric: 'Costo por Lead',
  before: '$250 - $400 (Y basura)',
  after: '$45 - $85 (Cualificado)'
}, {
  metric: 'Tasa de Cierre',
  before: '10% (Peleando precio)',
  after: '35% - 50% (Autoridad)'
}, {
  metric: 'Previsibilidad',
  before: '"A ver si llaman"',
  after: 'Agenda Llena Diario'
}];
export function ResultsSection() {
  return <section className="py-16 md:py-24 px-4 bg-carbon" data-id="element-124">
      <div className="max-w-5xl mx-auto" data-id="element-125">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-2xl md:text-4xl font-heading font-bold text-gold text-center mb-10 md:mb-16" data-id="element-126">
          Aquí es donde se acaba la opinión y empiezan los contratos.
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-127">
          {/* Desktop Table */}
          <div className="hidden md:block bg-[#0A0A0A] border border-[#151515] rounded-xl overflow-hidden shadow-lg" data-id="element-128">
            <table className="w-full text-left border-collapse" data-id="element-129">
              <thead data-id="element-130">
                <tr className="bg-gold/10 border-b border-[#151515]" data-id="element-131">
                  <th className="px-6 py-4 text-gold font-bold text-lg" data-id="element-132">
                    Métrica
                  </th>
                  <th className="px-6 py-4 text-gold font-bold text-lg" data-id="element-133">
                    Antes (Leads Genéricos)
                  </th>
                  <th className="px-6 py-4 text-gold font-bold text-lg" data-id="element-134">
                    Después (Sistema A.C.E.™)
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-135">
                {comparisonData.map((row, index) => <tr key={index} className="border-b border-[#151515] last:border-0" data-id="element-136">
                    <td className="px-6 py-5 text-white font-semibold text-lg" data-id="element-137">
                      {row.metric}
                    </td>
                    <td className="px-6 py-5 text-gray-sec" data-id="element-138">{row.before}</td>
                    <td className="px-6 py-5 text-emerald font-bold text-lg" data-id="element-139">
                      {row.after}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          {/* Mobile Stacked Cards */}
          <div className="md:hidden space-y-4" data-id="element-140">
            {comparisonData.map((row, index) => <div key={index} className="bg-[#0A0A0A] border border-[#151515] rounded-xl p-5 shadow-lg" data-id="element-141">
                <h3 className="text-white font-semibold text-lg mb-4 border-b border-[#151515] pb-2" data-id="element-142">
                  {row.metric}
                </h3>
                <div className="space-y-3" data-id="element-143">
                  <div data-id="element-144">
                    <span className="block text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-145">
                      Antes
                    </span>
                    <span className="text-gray-sec" data-id="element-146">{row.before}</span>
                  </div>
                  <div data-id="element-147">
                    <span className="block text-xs text-gold/70 uppercase tracking-wider mb-1" data-id="element-148">
                      Después
                    </span>
                    <span className="text-emerald font-bold text-lg" data-id="element-149">
                      {row.after}
                    </span>
                  </div>
                </div>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}